// extracted by mini-css-extract-plugin
export default {"packagePricing":"_3CJNbB9yNixZLo6C0YJsid"};